<template>
  <a-layout>
    <Breadcrumb>
      <BreadcrumbItem> {{ pageTitle }} </BreadcrumbItem>
    </Breadcrumb>
    <div class="page-title-container">
      <div>
        <span class="page-title">项目公司</span>
      </div>
    </div>

    <div class="content-container">
      <div class="container">
        <div class="steps-content">
          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label">公司名称</span><span class="required-mark">*</span>
            </div>
            <div class="field-content">
              <a-input v-model="company.companyName" class="medium-input" />
            </div>
          </div>
          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label">所属资源合作方</span><span class="required-mark">*</span>
            </div>
            <div class="field-content">
              <a-select
                  placeholder="请选择资源合作方"
                  v-model="company.partnerId"
                  style="width: 60%">
                <a-select-option v-for="item in partnerOptions" :key="item.partnerId" :value="item.partnerId">
                  {{ item.partnerName }}
                </a-select-option>
              </a-select>
            </div>
          </div>
          <div v-if="isAdmin" class="field-container">
            <div class="field-label-container">
              <span class="field-label">股转完成状态</span><span class="required-mark">*</span>
            </div>
            <div class="field-content">
              <a-radio-group v-model="company.equityReady" name="radioGroup">
                <a-radio :value="false">
                  未完成
                </a-radio>
                <a-radio :value="true">
                  已完成
                </a-radio>
              </a-radio-group>
            </div>
          </div>
          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label required-field">营业执照</span>
            </div>
            <div class="field-content">
              <a-upload
                  name="file"
                  :multiple="false"
                  :action="uploadUrl"
                  :headers="headers"
                  :file-list="license.docList"
                  accept=".pdf,.doc,.docx, image/*"
                  @preview="onPreviewFile"
                  @change="onLicenseUpload"
              >
                <a-button> <a-icon type="upload" /> {{ license.title ? license.title: '点击上传' }} </a-button>
              </a-upload>
            </div>
          </div>
          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label optional-field">行政审批局出具工商登记底档</span>
            </div>
            <div class="field-content">
              <a-upload
                  name="file"
                  :multiple="false"
                  :action="uploadUrl"
                  :headers="headers"
                  :file-list="bizDoc.docList"
                  accept=".pdf,.doc,.docx, image/*"
                  @preview="onPreviewFile"
                  @change="onBizDocChange"
              >
                <a-button> <a-icon type="upload" /> {{ bizDoc.title ? bizDoc.title: '工商登记底档' }} </a-button>
              </a-upload>
            </div>
          </div>
          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label optional-field">公司章程</span>
            </div>
            <div class="field-content">
              <a-upload
                  name="file"
                  :multiple="false"
                  :action="uploadUrl"
                  :headers="headers"
                  :file-list="charter.docList"
                  accept=".pdf,.doc,.docx, image/*"
                  @preview="onPreviewFile"
                  @change="onCharterChange"
              >
                <a-button> <a-icon type="upload" /> 公司章程 </a-button>
              </a-upload>
            </div>
          </div>
        </div>

        <div class="action-container action-container__bottom">
          <a-button
              type="primary"
              @click="onSubmit"
              class="draft-btn"
          >
            保存
          </a-button>
          <a-button @click="navToListPage">
            取消
          </a-button>
        </div>
      </div>

      <DocPreview ref="docPreview" />
    </div>
  </a-layout>
</template>
<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import BreadcrumbItem from "@/components/BreadcrumbItem.vue";
import {createUser, loadUser, fetchInitialPwd, isUserAdmin} from "@/services/UserService";
import {fetchRoleList} from "@/services/RoleService";
import {listOptions} from "@/views/partner/PartnerApi";
import {baseURL} from "@/services/HttpService";
import DocPreview from "@/views/DocPreview.vue";
import {loadCompany, saveCompany} from "@/views/company/CompanyApi";

export default {
  components: {DocPreview, BreadcrumbItem, Breadcrumb },
  data() {
    return {
      pageTitle: "新增项目公司",
      id: "",
      initialPwd: "",
      partnerOptions: [],
      company: {
        companyId: "",
        companyName: "",
        partnerId: "",
        equityReady: "",
      },
      isAdmin: false,
      uploadUrl: baseURL + "/upload/spec",
      headers: {
        authorization: 'authorization-text',
      },
      license: {
        loading: false,
        docList: [],
        title: "营业执照"
      },
      bizDoc: {
        loading: false,
        docList: [],
        title: ""
      },
      charter: {
        loading: false,
        docList: [],
        title: "公司章程"
      },
    };
  },
  created() {
    this.id = this.$route.params.id;
    if(this.id==='0') {
      this.id = "";
    } else {
      this.pageTitle = "编辑公司信息";
      this.startLoadCompany();
    }
    isUserAdmin().then(resp => {
      if(resp.data.code === "SUCCESS") {
        this.isAdmin = resp.data.data;
      }
    });
    listOptions().then(response => {
      if (response.data.code === "SUCCESS") {
        this.partnerOptions = response.data.data;
      }
    });
  },
  mounted() {

  },
  methods: {
    startLoadCompany(){
      if (this.id && this.id !== "") {
        loadCompany(this.id).then(response => {
          if (response.data.code === "SUCCESS") {
            let bizData = response.data.data;
            this.company = bizData;
            this.buildDocList(bizData.bizDocList, 'bizDoc');
            this.buildDocList(bizData.licenseDocList, 'license');
            this.buildDocList(bizData.charterDocList, 'charter');
          } else {
            this.$message.error("数据加载失败: " + response.data.errorMsg);
          }
        }).catch(error => {
          this.$message.error("数据加载失败： " + error.message);
        });
      }
    },
    buildDocList(docList, propName) {
      if(docList && docList.length > 0) {
        for (let i = 0; i < docList.length; i++) {
          let doc = docList[i];
          this[propName].docList.push({
            uid: doc.uid,
            name: doc.name,
            status: 'done',
            url: this.viewUrl + doc.url
          });
        }
      }
    },
    // 上传营业执照
    onLicenseUpload(info){
      let fileList = [...info.fileList];

      fileList = fileList.map(file => {
        if (file.response) {
          file.url = this.viewUrl + file.response.data;
        }
        return file;
      });
      this.license.docList = fileList;
    },
    // 上传公司章程
    onCharterChange(info){
      let fileList = [...info.fileList];

      fileList = fileList.map(file => {
        if (file.response) {
          file.url = this.viewUrl + file.response.data;
        }
        return file;
      });
      this.charter.docList = fileList;
    },
    // 上传工商登记底档
    onBizDocChange(info){
      let fileList = [...info.fileList];

      fileList = fileList.map(file => {
        if (file.response) {
          file.url = this.viewUrl + file.response.data;
        }
        return file;
      });
      this.bizDoc.docList = fileList;
    },
    // 预览已上传文件
    onPreviewFile(doc){
      this.$refs.docPreview.previewFile(doc);
    },

    navToListPage() {
      this.$router.push({ name: "CompanyList" });
    },

    validateForm() {
      if(this.company.companyName==="") {
        return "请输入公司名称";
      }
      if(this.company.partnerId==="") {
        return "请选择所属资源合作方";
      }
      if(this.isAdmin && this.company.equityReady==="") {
        return "请选择股转完成状态";
      }
      if(this.license.docList.length===0) {
        return "请上传营业执照";
      }
      return "";
    },

    onSubmit(){
      let validateMsg = this.validateForm();
      console.log("validateMsg", ">"+validateMsg+"<");
      if(validateMsg===""){
        let params = {
          ...this.company,
          licenseDocList: [],
          bizDocList: [],
          charterDocList: [],
        }
        this.prepareDocList(this.license.docList, params, "licenseDocList");
        this.prepareDocList(this.bizDoc.docList, params, "bizDocList");
        this.prepareDocList(this.charter.docList, params, "charterDocList");
        console.log("保存参数", params);

        saveCompany(params).then(response => {
          if (response.data.code === "SUCCESS") {
            this.$message.success("操作成功");
            this.$router.push({ name: "CompanyList" });
          } else {
            this.$message.error(response.data.errorMsg);
          }
        });
      } else {
        this.$message.error(validateMsg);
      }
    },

    prepareDocList(docList, params, propName){
      if(docList.length > 0) {
        for (let i = 0;i< docList.length; i++) {
          let oneDoc = docList[i];
          params[propName].push({
            uid: oneDoc.uid,
            name: oneDoc.name,
            url: oneDoc.url.replace(this.viewUrl, '')
          });
        }
      }
    },

  }
}
</script>
<style scoped>

.long-input {
  max-width: 80%;
}
.medium-input {
  max-width: 60%;
}
.remark-input {
  max-width: 30%;
}
.field-label-container {
  padding-top: 10px;
  padding-bottom: 10px;
  color: rgba(0, 0, 0, 0.85)
}
.draft-btn {
  margin-right: 30px;
}
</style>
